// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	let form_id_490 = document.querySelector( "#form_id-490" );
	if( form_id_490 ){

		let a_container = document.querySelector( ".form-module__field.input.col-12.field_490_2 " )
		
		let link = document.createElement( "a" );
		link.href = "https://www.opentable.com/r/domingo-restaurante-san-antonio?corrid=1889563c-cf36-497c-abca-f3ecfcf25b1e&avt=eyJ2IjoyLCJtIjowLCJwIjowLCJzIjowLCJuIjowfQ&p=2&sd=2022-10-27T19%3A00%3A00";
		link.innerHTML = "Reserve a Table";
		link.target = "_blank";
		link.style.margin = "20px"
		link.classList.add( "btn" );

		//a_container.prepend( link );

	}

	$(document).ready(function () {


		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		

	/** Tag footer hours based on URL keywords **/
		let URL = window.location.href;
		let lastSegment =null;

		const footer = document.getElementById("footerElement");

		if (URL.includes('/otro-bar')) {
			lastSegment = 'otro-bar';
		} else if (URL.includes('/domingo')) {
			lastSegment = 'domingo';
		}  
		else if (URL.includes('/lo-cura')) { 
			lastSegment = 'lo-cura';
		}
		else{
			lastSegment = null;
		}
		
		fetch(`/ajax/functions.php?operation=getHourFooter&tag=${lastSegment}`,{method: "GET"})
		.then((resp) => resp.json())
		.then((data) => {
			console.log(data);
			footer.innerHTML = data[0].short_description;
		})
	


	});
	$(window).scroll(function(event){
		var st = $(this).scrollTop();
		if(st > 20){
			if (st > lastScrollTop){
				// downscroll code
				if(!document.getElementById('header').classList.contains('down')){
					document.getElementById('header').classList.add('down');
					document.getElementById('header').classList.remove('up');
				}
			} else {
				// upscroll code
				if(!document.getElementById('header').classList.contains('up')){
					document.getElementById('header').classList.add('up');
					document.getElementById('header').classList.remove('down');
				}
			}
		} else {
			if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.remove('up');
				document.getElementById('header').classList.remove('down');
			}
		}
		lastScrollTop = st;
	});
	
	

	document.addEventListener("DOMContentLoaded", function() {
		let newLink = document.querySelector('#third-nav ul li:nth-child(1) a');

		if (newLink) {
			let faq_url = window.location.pathname;

			if (faq_url.includes('/lo-cura')) {
				newLink.href = '/lo-cura/faq-lo-cura';
			} else if (faq_url.includes('/otro-bar')) {
				newLink.href = '/otro-bar/faq-otro-bar';
			} else {
				newLink.href = '/faq';
			}
		}
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/
		if(!document.getElementById('cura-home')){
			scrollDownAction(20, 'scroll');

			scrollW();
			window.addEventListener('scroll', function(){
				scrollW();
			})
		}
	};

	const mobile_popup = document.querySelector('.mobile_popup');

	if(mobile_popup) { 
		document.getElementsByClassName('mobile_popup')[0].style.display = "none";
	}

	if(document.querySelector('.js-letters')){
		let allTitles = document.querySelectorAll('.js-letters');

		allTitles.forEach((title)=>{			
			let text_array = title.innerText.split('');
			title.textContent = '';
			text_array = text_array.reverse();
			for(var i = 0; i< text_array.length; i++){
				title.innerHTML += '<span style="transform:rotate('+(((i+271)+1)*7)+'deg)">'+ '<strong>'+text_array[i]+'</strong>' +'</span>';
			}
		})
	}
}());
 